import React, { useEffect } from 'react'

import { AboutUs, SpecialMenu } from './container'
import { Navbar } from './components'
import { Spinner } from 'react-redux-spinner'
import { useSnackbar } from 'notistack'
import { useSelector } from 'react-redux'
import { Grow } from '@mui/material'

import './App.css'

const App = () => {
  const { enqueueSnackbar } = useSnackbar()
  const menuDataFetchError = useSelector(state => state.menuData.error)

  useEffect(() => {
    if (menuDataFetchError !== '') {
      enqueueSnackbar(`Noget gik galt under hentning af menudata: ${menuDataFetchError}`, {
        variant: 'error',
        TransitionComponent: Grow,
        anchorOrigin: { vertical: 'bottom', horizontal: 'center' },
        preventDuplicate: true,
      })
    }
  }, [menuDataFetchError])

  return (
    <>
      <Navbar />
      <AboutUs />
      <SpecialMenu />
      <Spinner config={{ easing: 'ease' }} />
    </>
  )
}

export default App
